<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div v-show="Isblur" class="splash"></div>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width: 9vw;">لیست کاربران</h2>

              <div class="d-flex justify-content-between">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;" placeholder="جستجو بر اساس کد پرسنلی و نام و نام خانوادگی  ...">
                <p v-if="add_show"  class="btn btn-primary btn-add-org-post" href="#" style="width: 7vw; margin-right: 1vw;"
                   @click="addModalMethod"> افزودن </p>
              </div>
            <hr>
            </div>
            <div class="table-responsive mt-3">
              <div style="overflow-y: scroll; height: 50vw;" :style="filteredItems.length < 19 ? 'height: auto;' : ''">

              <table   class="table table-striped">
                <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام و نام خانوادگی</th>
                  <th>نام کاربری</th>
                  <th> شماره موبایل  </th>
                  <th   style="width: 5vw;"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in filteredItems" :key="item.id">
                  <td scope="row">{{ index + 1 }}</td>
                  <td>{{ item['fullname'] }}</td>
                  <td>{{ item['username']??'--' }}</td>
                  <td>{{ item['phone'] && item['phone'] !=='null' ? item['phone'] : '--' }}</td>


                  <td >
                    <a  @click.prevent="edit(item['id'], index)" href="#"><img class="table-edit-img"
                                                                       src="../../assets/img/pen.svg" alt="edit"></a>
                    &nbsp;
                    <a @click.prevent="deleteItem(item['id'], index)" href="#"><img class="table-delete-img mr-1"
                                                                             src="../../assets/img/delete.svg"
                                                                             alt="delete"></a>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-show="addModal" dir="rtl" class="col-lg-12 modal__for_fn" :style="loading ? 'filter: blur(0.3vw);' : ''" style="width: 40vw;">
    <div class="card card-body card-panel-box border-0" style="background-color: #F4FCFF; margin: 0;">
      <h2 v-if="false" style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
      <!-- Jobs -->
      <div class="row">
        <div class="col-lg-12 ps-1">
          <div class="card card-body card-panel-box border-0">
            <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
            <form class="needs-validation" novalidate>
              <div class="row">

                <div class="col-lg-6 mb-3">
                  <label class="form-label required">نام</label>
                  <input v-model="firstname" class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-6 mb-3 ">
                  <label class="form-label required">  نام خانوادگی</label>
                  <input v-model="lastname" class="form-control" type="text" name="" required>
                </div>
              </div>




              <div class="row">
                <div class="col-lg-12 mb-3">
                  <label class="form-label">تلفن همراه</label>
                  <input v-model="phone" class="form-control" type="number" name="" required>
                </div>

              </div>



              <div class="form-buttons row d-flex justify-content-around">
                <button @click.prevent="addModalMethod" class="btn btn-primary btn-back" type="submit">برگشت</button>
                <button @click.prevent="submitForm" class="btn btn-primary btn-approve justify-content-evenly"
                        type="submit">تایید<span
                    v-show="loading" class="loader"></span></button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-show="editModal" dir="rtl" class="col-lg-12 modal__for_fn" :style="loading ? 'filter: blur(0.3vw);' : ''" style="width: 40vw;">
    <div class="card card-body card-panel-box border-0" style="background-color: #F4FCFF; margin: 0; border-radius: unset;">
      <div class="row">
        <div class="col-lg-12 ps-1">
          <div class="card card-body card-panel-box border-0">
            <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
            <form class="needs-validation" novalidate>
              <div class="row">

                <div class="col-lg-6 mb-3">
                  <label class="form-label required">نام</label>
                  <input v-model="firstname" class="form-control" type="text" name="" required>
                </div>
                <div class="col-lg-6 mb-3 ">
                  <label class="form-label required">  نام خانوادگی</label>
                  <input v-model="lastname" class="form-control" type="text" name="" required>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mb-3">
                  <label class="form-label">تلفن همراه</label>
                  <input v-model="phone" class="form-control" type="number" name="" required>
                </div>

              </div>



              <div class="form-buttons row d-flex justify-content-around">
                <button @click.prevent="editMethod" class="btn btn-primary btn-back" type="submit">برگشت</button>
                <button @click.prevent="updateForm(id)" class="btn btn-primary btn-approve  justify-content-evenly"
                        type="submit">تایید<span
                    v-show="loading" class="loader"></span></button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- !todo: roles -->



  <!-- modal  -->

  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="showSign" style="z-index: 999999999999999">
    <div>
      <p>تصویر امضا</p>
      <p @click="showSign=!showSign">❌</p>
    </div>
    <div>
      <img class=" img-fluid" style="height: 18vw; width: 18vw;" :src="`${this.download_url}/${img}`" alt="">


      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="showSign=!showSign" class="btn btn-primary btn-back" type="submit">برگشت</button>
       </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import cookies from "vue-cookies";
import router from "@/router";
import {useToast} from "vue-toastification";
import login from "@/views/auth/Login.vue";
const toast = useToast();
export default {
  name: "ListUser",
  components: {Sidebar, Splash, Vue3PersianDatetimePicker},
  data() {
    return {
      ErrorM: '',
      Error: false,
      showSign: false,
      img: '',
      deleteModal: false,
      loading: false,
      addModal: false,
      editModal: false,
      Isblur: false,
      roleOne: false,
      roleTwo: false,
      roleTree: false,
      // info models
      personalCode: '',
      fullname: '',
      username: '',
      password: '',
      firstname: '',
      lastname: '',
      start_date: '',
      end_date: '',
      phone: '',
      tel: '',
      tel_code: '',
      location_work: '',
      post: '',
      note: '',
      // info rules one
      roleOne_one_viewer: false,
      roleOne_one_inserter: false,
      roleOne_one_submit: false,
      roleOne_one_management: false,
      roleOne_two_viewer: false,
      roleOne_two_inserter: false,
      roleOne_two_submit: false,
      roleOne_two_management: false,
      roleOne_tree_viewer: false,
      roleOne_tree_inserter: false,
      roleOne_tree_submit: false,
      roleOne_tree_management: false,
      // info rules two
      roleTwo_one_viewer: false,
      roleTwo_one_inserter: false,
      roleTwo_one_submit: false,
      roleTwo_one_management: false,
      roleTwo_two_viewer: false,
      roleTwo_two_inserter: false,
      roleTwo_two_submit: false,
      roleTwo_two_management: false,
      roleTwo_tree_viewer: false,
      roleTwo_tree_inserter: false,
      roleTwo_tree_submit: false,
      roleTwo_tree_management: false,
      roleTwo_four_viewer: false,
      roleTwo_four_inserter: false,
      roleTwo_four_submit: false,
      roleTwo_four_management: false,
      roleTwo_five_viewer: false,
      roleTwo_five_inserter: false,
      roleTwo_five_submit: false,
      roleTwo_five_management: false,
      roleTwo_six_viewer: false,
      roleTwo_six_inserter: false,
      roleTwo_six_submit: false,
      roleTwo_six_management: false,
      roleTwo_seven_viewer: false,
      roleTwo_seven_inserter: false,
      roleTwo_seven_submit: false,
      roleTwo_seven_management: false,
      // info rules tree
      roleTree_one_viewer: false,
      roleTree_one_inserter: false,
      roleTree_one_submit: false,
      roleTree_one_management: false,
      roleTree_two_viewer: false,
      roleTree_two_inserter: false,
      roleTree_two_submit: false,
      roleTree_two_management: false,
      roleTree_tree_viewer: false,
      roleTree_tree_inserter: false,
      roleTree_tree_submit: false,
      roleTree_tree_management: false,
      roleTree_four_viewer: false,
      roleTree_four_inserter: false,
      roleTree_four_submit: false,
      roleTree_four_management: false,
      roleTree_five_viewer: false,
      roleTree_five_inserter: false,
      roleTree_five_submit: false,
      roleTree_five_management: false,
      roleTree_six_viewer: false,
      roleTree_six_inserter: false,
      roleTree_six_submit: false,
      roleTree_six_management: false,
      // users
      all_users: [],
      id: 0,
      searchUser:'',
      // middleware
      add_show: true,
      ED_show: false,
      active_show: false,
      show_list: false,
      organizational_route_show: false,


    }
  },
  methods: {
    showImage(file){
      if (!file){
        toast.error('امضا بارگذاری نشده است!')
        return;
      }
      this.img =file
      this.showSign =true

    },
    activeMethod(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/active/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.fetchItems()

          })
          .catch();
    },
    deleteItem(id,type) {
      if (type===0){
        toast.error('امکان حذف برای شما وجود ندارد!')
        return;
      }
      this.deleteModal = true
      this.id = id
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/delete/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.Error= true
              this.ErrorM= result.error
            }
            this.deleteModal = false
            this.fetchItems()

          })
          .catch();
    },
    editMethod() {
      this.editModal = false
      this.Isblur = false

    },
    edit(id,type) {
      if (type===0){
        toast.error('امکان ویرایش برای شما وجود ندارد!')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.editModal = true
            this.id = id
            const item = result['item']
            if (item) {
              console.log(item)
              this.fullname = item['fullname']
              this.firstname = item['firstname']
              this.lastname = item['lastname']
              this.phone = item['phone']
            }

          })
          .catch();
    },
    fetchItems() {
      this.all_users.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['users'].length !== 0) {
              result['users'].forEach(item => {
                this.all_users.push(item)

              })

            }

          })
          .catch();
    },
    submitForm() {
      this.loading = !this.loading


      setTimeout(() => {
       if (this.firstname.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'نام اجباری است!'
          toast.error(this.ErrorM)

          this.loading = false

          return;
        }
        else if (this.lastname.length === 0) {
          this.Error = !this.Error
          this.ErrorM = '  نام خانوادگی اجباری است!'
          toast.error(this.ErrorM)

          this.loading = false

          return;
        }


        const formData = new FormData();
        formData.append('personal_code', this.personalCode);
        formData.append('username', this.username);
        formData.append('password', this.password);
        formData.append('fullname', this.firstname +' ' + this.lastname);
        formData.append('firstname', this.firstname);
        formData.append('lastname', this.lastname);
        formData.append('start_date', this.start_date);
        formData.append('end_date', this.end_date);
        formData.append('phone', this.phone);
        formData.append('tel', this.tel);
        formData.append('code_tel', this.tel_code);
        formData.append('address_activity', this.location_work);
        formData.append('post', this.post);
        formData.append('note', this.note);

        fetch(`${this.base_url}/user/store`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
          },
          body: formData,
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.error(response['error']);
                return;
              }
              this.all_users.length = 0;
              this.fetchItems();
              this.resetAll();
              this.addModal = false;
              this.Isblur = !this.Isblur;
            })
            .catch((err) => {
              // Handle error
            })
            .finally(() => {
              this.loading = false;
            });
      }, 1000);


    },
    updateForm(id) {
      this.loading = !this.loading


      setTimeout(() => {
        if (this.firstname.length === 0) {
          this.Error = !this.Error
          this.ErrorM = 'نام اجباری است!'
          toast.error(this.ErrorM)

          this.loading = false

          return;
        }
        else if (this.lastname.length === 0) {
          this.Error = !this.Error
          this.ErrorM = '  نام خانوادگی اجباری است!'
          toast.error(this.ErrorM)

          this.loading = false

          return;
        }


        const formData = new FormData();
        formData.append('username', this.username);
        formData.append('password', this.password);
        formData.append('fullname', this.firstname +' ' + this.lastname);
        formData.append('firstname', this.firstname);
        formData.append('lastname', this.lastname);
        formData.append('start_date', this.start_date);
        formData.append('end_date', this.end_date);
        formData.append('phone', this.phone);
        formData.append('tel', this.tel);
        formData.append('code_tel', this.tel_code);
        formData.append('address_activity', this.location_work);
        formData.append('post', this.post);
        formData.append('note', this.note);


        fetch(`${this.base_url}/user/update/${id}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
          },
          body: formData,
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.error(response['error']);
                return;
              }
              this.all_users.length = 0;
              this.fetchItems();
              this.resetAll();
              this.editModal = false;
              this.Isblur = false;
            })
            .catch((err) => {
              // Handle error
            })
            .finally(() => {
              this.loading = false;
            });
      }, 1000);
    },
    resetAll() {
      this.personalCode = ''
      this.fullname = ''
      this.username = ''
      this.firstname = ''
      this.lastname = ''
      this.password = ''
      this.start_date = ''
      this.end_date = ''
      this.phone = ''
      this.tel = ''
      this.tel_code = ''
      this.location_work = ''
      this.post = ''
      this.note = ''
      this.roleOne_one_viewer = false;
      this.roleOne_one_inserter = false;
      this.roleOne_one_submit = false;
      this.roleOne_one_management = false;
      this.roleOne_two_viewer = false;
      this.roleOne_two_inserter = false;
      this.roleOne_two_submit = false;
      this.roleOne_two_management = false;
      this.roleOne_tree_viewer = false;
      this.roleOne_tree_inserter = false;
      this.roleOne_tree_submit = false;
      this.roleOne_tree_management = false;
      this.roleTwo_one_viewer = false
      this.roleTwo_one_inserter = false
      this.roleTwo_one_submit = false
      this.roleTwo_one_management = false
      this.roleTwo_two_viewer = false
      this.roleTwo_two_inserter = false
      this.roleTwo_two_submit = false
      this.roleTwo_two_management = false
      this.roleTwo_tree_viewer = false
      this.roleTwo_tree_inserter = false
      this.roleTwo_tree_submit = false
      this.roleTwo_tree_management = false
      this.roleTwo_four_viewer = false
      this.roleTwo_four_inserter = false
      this.roleTwo_four_submit = false
      this.roleTwo_four_management = false
      this.roleTwo_five_viewer = false
      this.roleTwo_five_inserter = false
      this.roleTwo_five_submit = false
      this.roleTwo_five_management = false
      this.roleTwo_six_viewer = false
      this.roleTwo_six_inserter = false
      this.roleTwo_six_submit = false
      this.roleTwo_six_management = false
      this.roleTwo_seven_viewer = false
      this.roleTwo_seven_inserter = false
      this.roleTwo_seven_submit = false
      this.roleTwo_seven_management = false
      this.roleTree_one_viewer = false
      this.roleTree_one_inserter = false
      this.roleTree_one_submit = false
      this.roleTree_one_management = false
      this.roleTree_two_viewer = false
      this.roleTree_two_inserter = false
      this.roleTree_two_submit = false
      this.roleTree_two_management = false
      this.roleTree_tree_viewer = false
      this.roleTree_tree_inserter = false
      this.roleTree_tree_submit = false
      this.roleTree_tree_management = false
      this.roleTree_four_viewer = false
      this.roleTree_four_inserter = false
      this.roleTree_four_submit = false
      this.roleTree_four_management = false
      this.roleTree_five_viewer = false
      this.roleTree_five_inserter = false
      this.roleTree_five_submit = false
      this.roleTree_five_management = false
      this.roleTree_six_viewer = false
      this.roleTree_six_inserter = false
      this.roleTree_six_submit = false
      this.roleTree_six_management = false

    },

    addModalMethod() {
      this.resetAll();
      this.addModal = !this.addModal
      this.Isblur = !this.Isblur
    },
    _checking() {

    },
    checkIsMother(){
     if (this.is_mother){
       router.push('/mother_items')
     }

    }
  },
  mounted() {
    this.fetchItems()
    this.checkIsMother()
    this._checking()
  },
  computed:{
    filteredItems() {
      return this.all_users.filter(item => {
        return (
            item['personal_code'].includes(this.searchUser) || item['fullname'].includes(this.searchUser)
        );
      });
    },
  }
}
</script>

<style scoped lang="scss">
label {
  width: 100%;
  text-align: right;
}



p, label {
  font-size: 1vw !important;
}

input[type=checkbox] {
  width: 1vw;
  height: 1vw;
  border-radius: .5vw;
  border: .2vw solid #eee;
}

.text-end {
  font-weight: bold;
}
.change_div{
  background: #fff;
  width: 20vw;
  padding: 1vw;
  margin-left: 5vw;
  border-radius: 1vw;
}
</style>